import { Injectable, type Provider } from '@angular/core';

import { ok, type ApiResult } from '../../../core/models/api-result';
import { HubsHeadsUpService } from './hubs-heads-up.service';
import type { BuildingAlertForMe } from './hubs-rail.models';

/**
 * THE HEADS-UP STRIP, WITHOUT A SESSION (`/preview/hubs`): Dean's fire drill
 * on Thursday at 10:00, building-wide, so it carries no personal line and no
 * action. The second alert is the one with an action ("Move my desk"); it
 * shows once the drill is dismissed, so the harness exercises both shapes.
 */

function nextThursdayAtTen(): string {
  const d = new Date();
  d.setDate(d.getDate() + ((4 - d.getDay() + 7) % 7 || 7));
  d.setHours(10, 0, 0, 0);
  return d.toISOString();
}

export function previewHeadsUps(): readonly BuildingAlertForMe[] {
  const start = nextThursdayAtTen();
  return [
    {
      affectsMyBooking: false,
      dismissed: false,
      isActive: false,
      personalLine: null,
      alert: {
        _id: 'alert-drill',
        title: 'Fire drill on Thursday at 10:00',
        description: 'Rum Runner Works · about 15 minutes, meet in the yard',
        category: 'DRILL',
        severity: 'INFO',
        startTime: start,
        endTime: new Date(Date.parse(start) + 15 * 60_000).toISOString(),
        actionLabel: null,
        actionUrl: null,
        targets: [{ locationId: 'loc-rrw' }],
      },
    },
    {
      affectsMyBooking: true,
      dismissed: false,
      isActive: false,
      personalLine: 'Your Wednesday desk is on Level 4',
      alert: {
        _id: 'alert-closure',
        title: 'Level 4 closes on Wednesday',
        description: null,
        category: 'CLOSURE',
        severity: 'WARNING',
        startTime: start,
        endTime: null,
        actionLabel: 'Move my desk',
        actionUrl: '/schedule',
        targets: [{ locationId: 'loc-rrw' }],
      },
    },
  ];
}

@Injectable()
export class HubsHeadsUpPreviewService extends HubsHeadsUpService {
  protected override async fetch(): Promise<ApiResult<readonly BuildingAlertForMe[] | null>> {
    return ok(previewHeadsUps());
  }

  protected override async sendDismiss(): Promise<ApiResult<boolean | null>> {
    return ok(true);
  }
}

export const HUBS_HEADS_UP_PREVIEW_PROVIDER: Provider = {
  provide: HubsHeadsUpService,
  useClass: HubsHeadsUpPreviewService,
};
